import jwtDecode from 'jwt-decode'

// Ten second buffer so the token is refreshed slightly early. A token that
// cannot be decoded is treated as expired so it is refreshed or dropped
// instead of sent.
export const isExpired = (token: string): boolean => {
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token)
    const epoch = Math.floor(Date.now() / 1000) + 10
    return !exp || exp < epoch
  } catch {
    return true
  }
}
